// Class name helper: clsx for conditional classes and tailwind-merge (taught the NX type scale, radii, shadows, tracking, easing and animations) so later utilities win.
import { clsx, type ClassValue } from "clsx";
import { extendTailwindMerge } from "tailwind-merge";

const twMerge = extendTailwindMerge({
  extend: {
    theme: {
      text: [
        "micro",
        "kbd",
        "label",
        "caption",
        "chip",
        "ui",
        "btn",
        "lead",
        "section",
        "ws",
        "verdict",
        "h1",
        "kpi",
        "hero",
      ],
      radius: ["pill"],
      shadow: ["1", "2", "pop", "primary", "paper", "lift", "seg"],
      tracking: ["hero", "h1", "kpi", "caps", "eyebrow"],
      ease: ["nx"],
      animate: ["pop", "fade", "slide", "fade-in", "stripes", "blink", "scan"],
    },
  },
});

export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}

export const linkClass = "text-brand-blue underline-offset-2 hover:underline";
